import { ProjectSearchResponse } from '@/types/service-response'

export class ProjectSearch {
  public constructor (
    readonly ID: number,
    readonly Titel: string,
    readonly Nummer: string,
    readonly Gesperrt: boolean,
    readonly IhreReferenz: string,
    readonly Sachbearbeiter: string,
    readonly UnsereReferenz: string,
    readonly Adresse: string,
    readonly AdressNummer: string,
    readonly ProzessArtCode: string,
    readonly ProzessArtBezeichnung: string,
    readonly Projektdatum: string,
    readonly NaechsterSchritt: string,
    readonly DetailPosition: string,
    readonly ProduktNummer: string,
    readonly ProduktBez: string,
    readonly PGCode: string,
    readonly DetailMenge: string,
    readonly DetailEinheit: string,
    readonly ProzessartDetail: string,
    readonly RowColor: string,
    readonly FontColor: string
  ) {}

  static createFromResponse (responseData: ProjectSearchResponse[]): Array<ProjectSearch> {
    let result: Array<ProjectSearch> = []
    if (responseData) {
      result = responseData.map((item: ProjectSearchResponse ) => {
        return new ProjectSearch(
          item.ID,
          item.Titel,
          item.Nummer,
          item.Gesperrt ? true : false,
          item.IhreReferenz,
          item.Sachbearbeiter,
          item.UnsereReferenz,
          item.Adresse,
          item.AdressNummer,
          item.ProzessArtCode,
          item.ProzessArtBezeichnung,
          item.Projektdatum,
          item.NaechsterSchritt,
          item.DetailPosition,
          item.ProduktNummer,
          item.ProduktBez,
          item.PGCode,
          item.DetailMenge,
          item.DetailEinheit,
          item.ProzessartDetail,
          item.RowColor,
          item.FontColor
        )
      })
    }
    return result
  }
}
